<div *ngIf="data.length">
  <div class="page-title">{{ 'DASHPAGES.Feedback_Requests' | translate }}</div>

  <div class="table-container">
    <table [id]="tableId" class="display"></table>
  </div>
</div>
